module.exports = __webpack_public_path__ + "media/Fire_station.7aee6308.mp3";